<app-modal #modal [title]="'Scansione QRCode/Barcode'">
    <div class="alert alert-info mt-2" *ngIf="container_connected">
        <button class="btn btn-outline-primary btn-block" (click)="startScan()">Apri il lettore QRCode/Barcode del dispositivo</button>
    </div>
    
    <zxing-scanner *ngIf="!container_connected" [tryHarder]="true" [autofocusEnabled]="true"  [formats]="formats" [autostart]="true" #scanner  (scanSuccess)="scanCompleteHandler($event)"></zxing-scanner>

</app-modal>